import { Link } from "react-router-dom";
import type { Transfer } from "@/types";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export function TransferRow({ transfer, href }: { transfer: Transfer; href: string }) {
  const send = transfer.direction === "send";
  return (
    <tr className="border-b border-line last:border-b-0 hover:bg-bg">
      <td className="px-4 py-3.5">
        <Link to={href} className="font-mono text-[13px] font-semibold text-primary transition-colors hover:underline">
          {transfer.id}
        </Link>
      </td>
      <td className={cn("px-4 py-3.5 text-[13px] font-medium", send ? "text-danger" : "text-success")}>
        {send ? "↑ Send" : "↓ Recv"}
      </td>
      <td className="px-4 py-3.5 text-[13px] text-text">{transfer.route}</td>
      <td className="px-4 py-3.5 text-[13px] font-medium text-ink">{transfer.asset}</td>
      <td className="px-4 py-3.5 font-mono text-[13px] tabular-nums text-ink">{transfer.amount}</td>
      <td className="px-4 py-3.5">
        <Badge variant={transfer.statusVariant} dot={false} size="sm">
          {transfer.statusLabel}
        </Badge>
      </td>
      <td className="px-4 py-3.5 text-[13px] text-muted">{transfer.created}</td>
      <td className="px-4 py-3.5 text-[13px] text-muted">{transfer.creator}</td>
      <td className="px-4 py-3.5">
        <button
          type="button"
          aria-label={`Open actions for ${transfer.id}`}
          className="grid size-7 place-items-center rounded-md text-muted transition-colors hover:bg-line hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-soft"
        >
          <span aria-hidden className="text-lg leading-none">···</span>
        </button>
      </td>
    </tr>
  );
}
